import { contacts } from '../static-data';
// export default (contact = (state = contacts, action) => {
// 	return state;
// });
const contact = (state = contacts, action) => {
	return state;
};
export default contact;
